import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from '../../../../../../../../context/ApplicationContext';
import { KOSTEN_ARTEN, PLATZHALTER_TEXT } from '../../../../../../../../lib/constants/constant';
import { DisplayEuroMUI } from '../../../../../../../../utils/formats';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../../lib/paths/antrag_FULL_Paths.json';
import kostenPositionSchema from '../../../../../../../../lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = kostenPositionSchema.attributes;

const PersonalKostenUebersichtAntragEmob: FC<{}> = () => {
	const { application } = useApplication();
	const columns = useMemo(() => {
		let column = [
			{ field: 'id', headerName: 'ID', width: 80, groupable: false },
			{ field: 'kostraeger', headerName: 'Kostenträger', flex: 1 },
			{ field: 'unternehmen', headerName: 'Unternehmen / Institution', flex: 1, groupable: false },
			{ field: 'name', headerName: 'Name', flex: 1, groupable: false },
			{ field: 'kostenart', headerName: 'Kostenart', flex: 1, groupable: false },
			{ field: 'kostenKategorie', headerName: 'Kostenkategorie', flex: 1, groupable: false },
			...Array.from({ length: get(application, P.Allgemein_Projektdauerin_Jahren.path) }).map((_, i) => {
				return {
					field: `${get(application, P.Allgemein_Projektstart_Jahr.path) + i}`,
					headerName: `${get(application, P.Allgemein_Projektstart_Jahr.path) + i}`,
					flex: 1,
					type: 'number' as const,
					valueFormatter: (value: any) => {
						return DisplayEuroMUI(value);
					},
				};
			}),
			{
				field: 'geplanteSumme',
				headerName: 'Geplante Summe',
				flex: 1,
				type: 'number' as const,
				valueFormatter: (value: any) => {
					return DisplayEuroMUI(value);
				},
			},
		];

		return column;
	}, [application]);

	const rows = useMemo(() => {
		let row = get(application, P.Foerderantrag_Kostenpositions.path, [])
			.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten)
			.map((ele: any) => {
				const kostenProJahr = get(ele, KP_P.Allgemein_Kosten_Pro_Jahr.path, []).reduce((acc: any, proJahr: any) => {
					acc[get(proJahr, 'Zelle_1')] = get(proJahr, 'Zelle_2');
					return acc;
				}, {});
				return {
					id: get(ele, 'id'),
					kostraeger: get(ele, KP_P.Allgemein_Kostentraeger.path, ''),
					unternehmen: get(ele, KP_P.Unternehmen.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path),
					name: get(ele, KP_P.Personalausgaben_Emob_Antrag.schema.attributes.Emob_Antrag_Name_Desder_Beschaeftigten.path),
					kostenart: get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path),
					kostenKategorie: get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path),
					...kostenProJahr,
					geplanteSumme: get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path),
				};
			});
		return row;
	}, [application]);

	const initialState: any = useMemo(() => {
		const projectStartYear = get(application, P.Allgemein_Projektstart_Jahr.path);
		const projectDurationYears = get(application, P.Allgemein_Projektdauerin_Jahren.path);

		const model: any = Array.from({ length: projectDurationYears }).reduce((acc: any, _, i) => {
			acc[projectStartYear + i] = 'sum';
			return acc;
		}, {});

		return {
			aggregation: {
				model: {
					...model,
					geplanteSumme: 'sum',
				},
			},
			rowGrouping: {
				model: ['unternehmen'],
			},
		};
	}, [application]);

	return (
		<>
			<ApplicationHeading title='Personalkosten Übersicht' description={PLATZHALTER_TEXT} />
			<DataGridPremium
				rows={rows}
				columns={columns}
				initialState={initialState}
				hideFooter
				disableRowSelectionOnClick
				localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
			/>
		</>
	);
};
export default PersonalKostenUebersichtAntragEmob;
